import Vue from 'vue';

import CityPickerPopover from './CityPickerUI.vue';

const element = document.querySelector('#data-config-city-picker-ui');
const location = JSON.parse(element.getAttribute('data-location-city-picker-ui'));
const params = JSON.parse(element.textContent);

export default (el) => {
  new Vue({
    el,
    render: (h) => h(CityPickerPopover, {
      props: {
        location,
        city         : params.city,
        isShowNotify : !!params.isShowNotify
      }
    })
  });
};
